(function () {
  'use strict';

  if (window.MrMapleSingleItemCheckout) return;

  var STASH_ENDPOINT = '/apps/garden/v1/buy-now-cart-stash';
  var STORAGE_KEY = 'mrmaple:buy-now-cart-stash';
  var COOKIE_KEY = 'mm_buy_now_cart_stash';
  var DEFAULT_CHECKOUT_PATH = '/checkout';
  var RESTORE_RETRY_THROTTLE_MS = 1500;

  var restoreInFlight = false;
  var checkoutStartInFlight = false;
  var lastRestoreAttemptAt = 0;

  function routePath(path) {
    var root = '/';
    try {
      root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    } catch (_) {
      root = '/';
    }
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function isPlainObject(value) {
    return !!value && Object.prototype.toString.call(value) === '[object Object]';
  }

  function compactObject(value) {
    if (!isPlainObject(value)) return {};
    var output = {};
    Object.keys(value).forEach(function (key) {
      if (typeof key !== 'string' || !key) return;
      var item = value[key];
      if (typeof item === 'undefined') return;
      output[key] = item;
    });
    return output;
  }

  function parseQuantity(value) {
    var parsed = parseInt(value, 10);
    if (isNaN(parsed) || parsed < 1) return 1;
    return Math.min(parsed, 999);
  }

  function normalizeVariantId(value) {
    if (typeof value === 'number' && isFinite(value)) return value;
    var stringValue = String(value || '').trim();
    if (!stringValue) return '';
    if (/^\d+$/.test(stringValue)) return parseInt(stringValue, 10);
    return stringValue;
  }

  function normalizeSellingPlan(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'number' && isFinite(value)) return value;
    var stringValue = String(value).trim();
    if (!stringValue) return null;
    var gidMatch = stringValue.match(/\/SellingPlan\/(\d+)$/);
    if (gidMatch) return parseInt(gidMatch[1], 10);
    if (/^\d+$/.test(stringValue)) return parseInt(stringValue, 10);
    return stringValue;
  }

  function normalizeCheckoutItem(item) {
    var id = normalizeVariantId(item && item.id);
    if (!id) {
      throw new Error('Missing checkout item variant.');
    }

    var normalized = {
      id: id,
      quantity: parseQuantity(item && item.quantity)
    };

    var properties = compactObject(item && item.properties);
    if (Object.keys(properties).length) normalized.properties = properties;

    var sellingPlan = normalizeSellingPlan(item && (item.selling_plan || item.sellingPlan));
    if (sellingPlan) normalized.selling_plan = sellingPlan;

    return normalized;
  }

  function extractSellingPlan(line) {
    if (!line) return null;
    if (line.selling_plan) return normalizeSellingPlan(line.selling_plan);
    if (line.selling_plan_id) return normalizeSellingPlan(line.selling_plan_id);
    var allocation = line.selling_plan_allocation || {};
    var sellingPlan = allocation.selling_plan || {};
    return normalizeSellingPlan(sellingPlan.id || sellingPlan.selling_plan_id || null);
  }

  function normalizeCartLine(line) {
    return {
      key: line && line.key ? String(line.key) : null,
      id: line && line.id != null ? line.id : null,
      variantId: normalizeVariantId(line && (line.variant_id || line.id)),
      quantity: parseQuantity(line && line.quantity),
      properties: compactObject(line && line.properties),
      sellingPlan: extractSellingPlan(line),
      title: String((line && (line.title || line.product_title)) || '').slice(0, 500) || null
    };
  }

  function extractDiscountCodes(cart) {
    var codes = [];
    [
      cart && cart.cart_level_discount_applications,
      cart && cart.discount_applications
    ].forEach(function (applications) {
      if (!Array.isArray(applications)) return;
      applications.forEach(function (application) {
        var code = application && application.code;
        if (code && typeof code === 'string' && codes.indexOf(code) === -1) {
          codes.push(code.slice(0, 120));
        } else if (application && application.title) {
          console.warn('[SingleItemCheckout] Cart discount could not be restored without a raw code', application.title);
        }
      });
    });
    return codes.slice(0, 20);
  }

  function normalizeCartSnapshot(cart) {
    var items = Array.isArray(cart && cart.items)
      ? cart.items.map(normalizeCartLine).filter(function (line) {
          return line.variantId && line.quantity > 0;
        })
      : [];

    return {
      token: cart && cart.token ? String(cart.token) : null,
      itemCount: typeof (cart && cart.item_count) === 'number' ? cart.item_count : items.length,
      note: cart && typeof cart.note === 'string' ? cart.note : '',
      attributes: compactObject(cart && cart.attributes),
      items: items,
      discountCodes: extractDiscountCodes(cart || {})
    };
  }

  function cartHasRestorableState(cart) {
    if (cart && typeof cart.item_count === 'number' && cart.item_count > 0) return true;
    if (cart && Array.isArray(cart.items) && cart.items.length) return true;
    if (cart && typeof cart.note === 'string' && cart.note) return true;
    if (Object.keys(compactObject(cart && cart.attributes)).length) return true;
    return extractDiscountCodes(cart || {}).length > 0;
  }

  function createCartError(message, status, payload) {
    var error = new Error(message || 'Cart request failed.');
    error.status = status || 0;
    error.payload = payload || null;
    return error;
  }

  function mergeHeaders(headers) {
    var output = {
      'Accept': 'application/json'
    };
    Object.keys(headers || {}).forEach(function (key) {
      output[key] = headers[key];
    });
    return output;
  }

  function readResponseJson(response) {
    return response.text().then(function (text) {
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch (_) {
        return null;
      }
    });
  }

  function fetchJson(url, options, fallbackMessage) {
    var init = options || {};
    init.credentials = init.credentials || 'same-origin';
    init.headers = mergeHeaders(init.headers);

    return fetch(url, init).then(function (response) {
      return readResponseJson(response).then(function (payload) {
        if (!response.ok) {
          throw createCartError(
            (payload && (payload.description || payload.message || payload.error)) || fallbackMessage,
            response.status,
            payload
          );
        }
        return payload;
      });
    });
  }

  function getCart() {
    return fetchJson(routePath('cart.js'), { method: 'GET' }, 'Unable to read cart.');
  }

  function clearCart() {
    return fetchJson(routePath('cart/clear.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({})
    }, 'Unable to clear cart.');
  }

  function addCartLine(line) {
    var body = {
      id: normalizeVariantId(line.variantId || line.id),
      quantity: parseQuantity(line.quantity)
    };
    var properties = compactObject(line.properties);
    if (Object.keys(properties).length) body.properties = properties;
    var sellingPlan = normalizeSellingPlan(line.sellingPlan || line.selling_plan);
    if (sellingPlan) body.selling_plan = sellingPlan;

    return fetchJson(routePath('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }, 'Unable to add item to cart.');
  }

  function addCheckoutItem(item) {
    return fetchJson(routePath('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }, 'Unable to add item to checkout.');
  }

  function updateCartMetadata(snapshot) {
    var body = {
      note: snapshot && typeof snapshot.note === 'string' ? snapshot.note : '',
      attributes: compactObject(snapshot && snapshot.attributes)
    };

    body.discount = snapshot && Array.isArray(snapshot.discountCodes) && snapshot.discountCodes.length
      ? snapshot.discountCodes.join(',')
      : '';

    return fetchJson(routePath('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }, 'Unable to restore cart metadata.');
  }

  function clearCheckoutMetadata(snapshot) {
    var attributes = compactObject(snapshot && snapshot.attributes);
    var discountCodes = Array.isArray(snapshot && snapshot.discountCodes) ? snapshot.discountCodes : [];
    var shouldClear = (snapshot && snapshot.note) || Object.keys(attributes).length || discountCodes.length;
    if (!shouldClear) return Promise.resolve();

    var clearedAttributes = {};
    Object.keys(attributes).forEach(function (key) {
      clearedAttributes[key] = '';
    });

    return fetchJson(routePath('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: '', attributes: clearedAttributes, discount: '' })
    }, 'Unable to prepare checkout cart.').catch(function (error) {
      console.warn('[SingleItemCheckout] Could not clear cart metadata before checkout', error);
    });
  }

  function dispatchCartEvents(detail) {
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail || {} }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: detail || {} }));
    document.dispatchEvent(new CustomEvent('product-form:cart:update', { bubbles: true, detail: detail || {} }));
  }

  function createServerStash(source, snapshot, targetItem) {
    return fetchJson(STASH_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'create',
        source: source || 'unknown',
        cartSnapshot: snapshot,
        targetItem: targetItem
      })
    }, 'Unable to stash cart.');
  }

  function getServerStash(pending) {
    var params = new URLSearchParams({
      stashId: pending.stashId,
      nonce: pending.nonce
    });
    return fetchJson(STASH_ENDPOINT + '?' + params.toString(), {
      method: 'GET'
    }, 'Unable to load stashed cart.');
  }

  function markServerStash(pending, action, reason) {
    if (!pending || !pending.stashId || !pending.nonce) return Promise.resolve();
    var body = {
      action: action,
      stashId: pending.stashId,
      nonce: pending.nonce
    };
    if (reason) body.reason = String(reason).slice(0, 500);

    return fetchJson(STASH_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }, 'Unable to update cart stash.').catch(function (error) {
      console.warn('[SingleItemCheckout] Could not mark cart stash', error);
    });
  }

  function setCookie(value, expiresAt) {
    try {
      var maxAge = Math.max(60, Math.floor((expiresAt - Date.now()) / 1000));
      var secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = COOKIE_KEY + '=' + encodeURIComponent(JSON.stringify(value)) +
        '; path=/; max-age=' + maxAge + '; SameSite=Lax' + secure;
    } catch (_) {}
  }

  function clearCookie() {
    try {
      document.cookie = COOKIE_KEY + '=; path=/; max-age=0; SameSite=Lax';
    } catch (_) {}
  }

  function readCookie() {
    try {
      var prefix = COOKIE_KEY + '=';
      var parts = String(document.cookie || '').split(';');
      for (var index = 0; index < parts.length; index += 1) {
        var part = parts[index].trim();
        if (part.indexOf(prefix) === 0) {
          return JSON.parse(decodeURIComponent(part.slice(prefix.length)));
        }
      }
    } catch (_) {}
    return null;
  }

  function savePending(token) {
    var pending = {
      stashId: token.stashId,
      nonce: token.nonce,
      expiresAt: token.expiresAt,
      createdAt: Date.now()
    };

    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
    } catch (_) {}
    setCookie(pending, pending.expiresAt);
    return pending;
  }

  function readPending() {
    var pending = null;
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      pending = raw ? JSON.parse(raw) : null;
    } catch (_) {
      pending = null;
    }

    if (!pending) pending = readCookie();
    if (!pending || !pending.stashId || !pending.nonce) return null;
    if (Number(pending.expiresAt || 0) <= Date.now()) {
      clearPending();
      return null;
    }
    return pending;
  }

  function clearPending() {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
    clearCookie();
  }

  function buildCheckoutUrl(path, query) {
    var checkoutPath = path || DEFAULT_CHECKOUT_PATH;
    var checkoutQuery = '';
    if (query instanceof URLSearchParams) {
      checkoutQuery = query.toString();
      checkoutQuery = checkoutQuery ? '?' + checkoutQuery : '';
    } else if (typeof query === 'string' && query) {
      checkoutQuery = query.charAt(0) === '?' ? query : '?' + query;
    }
    return checkoutPath + checkoutQuery;
  }

  function restoreCartSnapshot(snapshot) {
    var lines = Array.isArray(snapshot && snapshot.items) ? snapshot.items.slice() : [];
    var errors = [];

    var currentCart = null;

    return getCart()
      .then(function (cart) {
        currentCart = cart;
      })
      .catch(function (error) {
        console.warn('[SingleItemCheckout] Could not inspect cart metadata before restore', error);
      })
      .then(function () {
        return clearCart();
      })
      .then(function () {
        return clearCheckoutMetadata(currentCart);
      })
      .then(function () {
        return lines.reduce(function (promise, line) {
          return promise.then(function () {
            return addCartLine(line).catch(function (error) {
              errors.push({ line: line, error: error && error.message ? error.message : String(error) });
            });
          });
        }, Promise.resolve());
      })
      .then(function () {
        return updateCartMetadata(snapshot).catch(function (error) {
          errors.push({ line: null, error: error && error.message ? error.message : String(error) });
        });
      })
      .then(function () {
        dispatchCartEvents({ source: 'single-item-checkout:restore', errors: errors });
        return errors;
      });
  }

  function shouldSkipRestore() {
    if (checkoutStartInFlight || restoreInFlight) return true;
    var pathname = String(window.location.pathname || '').toLowerCase();
    return pathname.indexOf('/checkout') === 0 || pathname.indexOf('/checkouts') === 0;
  }

  function restorePending(reason) {
    if (shouldSkipRestore()) return Promise.resolve({ skipped: true });

    var now = Date.now();
    if (now - lastRestoreAttemptAt < RESTORE_RETRY_THROTTLE_MS) {
      return Promise.resolve({ skipped: true });
    }
    lastRestoreAttemptAt = now;

    var pending = readPending();
    if (!pending) return Promise.resolve({ skipped: true });

    restoreInFlight = true;
    return getServerStash(pending)
      .then(function (payload) {
        var snapshot = payload && payload.cartSnapshot;
        if (!snapshot || !Array.isArray(snapshot.items)) {
          clearPending();
          return markServerStash(pending, 'mark_failed', 'invalid_snapshot').then(function () {
            return { restored: false, errors: [{ error: 'invalid_snapshot' }] };
          });
        }

        return restoreCartSnapshot(snapshot).then(function (errors) {
          clearPending();
          if (errors.length) {
            return markServerStash(pending, 'mark_failed', 'partial_restore').then(function () {
              console.warn('[SingleItemCheckout] Cart restored with errors', errors);
              return { restored: false, errors: errors };
            });
          }
          return markServerStash(pending, 'mark_restored').then(function () {
            return { restored: true, errors: [] };
          });
        });
      })
      .catch(function (error) {
        if (error && (error.status === 404 || error.status === 409 || error.status === 410)) {
          clearPending();
          return { restored: false, expired: true };
        }
        console.warn('[SingleItemCheckout] Could not restore pending cart stash', error);
        return { restored: false, error: error };
      })
      .finally(function () {
        restoreInFlight = false;
      });
  }

  function start(options) {
    var config = options || {};
    var source = String(config.source || 'buy-now').slice(0, 80);
    var targetItem = normalizeCheckoutItem(config.item || {});
    var pending = null;
    var originalSnapshot = null;
    var loadingSet = false;

    function setLoading(value) {
      if (typeof config.setLoading === 'function') {
        loadingSet = value;
        config.setLoading(value);
      }
    }

    checkoutStartInFlight = true;
    setLoading(true);

    return getCart()
      .then(function (cart) {
        if (!cartHasRestorableState(cart)) return null;
        originalSnapshot = normalizeCartSnapshot(cart);
        return createServerStash(source, originalSnapshot, targetItem)
          .then(function (token) {
            pending = savePending(token);
            return clearCart();
          })
          .then(function () {
            return clearCheckoutMetadata(originalSnapshot);
          });
      })
      .then(function () {
        return addCheckoutItem(targetItem);
      })
      .then(function () {
        if (typeof config.beforeRedirect === 'function') {
          return config.beforeRedirect({
            source: source,
            item: targetItem,
            stash: pending,
            cartSnapshot: originalSnapshot
          });
        }
        return null;
      })
      .then(function () {
        dispatchCartEvents({ source: 'single-item-checkout:start', item: targetItem });
        window.location.href = buildCheckoutUrl(config.checkoutPath, config.checkoutQuery);
      })
      .catch(function (error) {
        var restorePromise = Promise.resolve();
        if (originalSnapshot) {
          restorePromise = restoreCartSnapshot(originalSnapshot)
            .then(function () {
              return markServerStash(pending, 'mark_failed', 'checkout_start_failed');
            })
            .catch(function (restoreError) {
              console.error('[SingleItemCheckout] Failed to restore cart after Buy Now error', restoreError);
            })
            .then(function () {
              clearPending();
            });
        }

        return restorePromise.then(function () {
          if (loadingSet) setLoading(false);
          throw error;
        });
      })
      .finally(function () {
        checkoutStartInFlight = false;
      });
  }

  function scheduleRestore(reason) {
    window.setTimeout(function () {
      restorePending(reason);
    }, 0);
  }

  window.MrMapleSingleItemCheckout = {
    start: start,
    restorePending: restorePending,
    _normalizeCartSnapshot: normalizeCartSnapshot
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleRestore('domcontentloaded');
    }, { once: true });
  } else {
    scheduleRestore('ready');
  }

  window.addEventListener('pageshow', function () {
    scheduleRestore('pageshow');
  });

  window.addEventListener('focus', function () {
    scheduleRestore('focus');
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      scheduleRestore('visibility');
    }
  });
})();
